import Glide from "@glidejs/glide";
import { getElements, ifSelectorExist } from "./utils";

export const JagSliders = () => {
  const carouselAwards = ".carousel-awards";
  if (ifSelectorExist(carouselAwards)) {
    Array.from(getElements(carouselAwards)).forEach((item) => {
      new Glide(item, {
        gap: 30,
        perView: 8,
        type: "carousel",
        animationDuration: 500,
        autoplay: 2500,
        breakpoints: {
          992: {
            perView: 6,
          },
          640: {
            perView: 4,
          },
        },
      }).mount();
    });
  }

  const wins = ".carousel-case-types";
  if (ifSelectorExist(wins)) {
    Array.from(getElements(wins)).forEach((item) => {
      new Glide(item, {
        gap: 30,
        perView: 4,
        type: "carousel",
        animationDuration: 500,
        autoplay: 2000,
        breakpoints: {
          992: {
            perView: 2,
          },
          640: {
            perView: 1,
          },
        },
      }).mount();
    });
  }

  const grSlider = ".reviews_slider";
  if (ifSelectorExist(grSlider) && document.querySelector(grSlider) !== null) {
    Array.from(getElements(grSlider)).forEach((item) => {
      new Glide(item, {
        perView: 3,
        type: "carousel",
        slideWidth: 1020,
        breakpoints: {
          1100: {
            perView: 2,
          },
          768: {
            perView: 1,
          },
        },
      }).mount();
    });
  }
};
